<template>
  <div class="container">
    <el-form label-width="120px" ref="form">
      <!--  -->
      <h2>教练搜索</h2>
      <el-form-item label="类目" required>
        <el-select v-model="categories" clearable>
          <el-option
            v-for="(item, index) in categories_child_list"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别" required>
        <el-radio-group v-model="coach.sex">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="性别" required>
        <div>{{ categories }}教练：{{ list.length }}人</div>
      </el-form-item>
      <el-form-item label="" required>
        <el-button type="primary" @click="queryCoach">搜索教练</el-button>
        <el-button type="danger" @click="list = []">清空</el-button>
      </el-form-item>
      <h2>转达人</h2>

      <el-form-item label="类型" required>
        <el-radio-group v-model="type">
          <el-radio label="expert">达人</el-radio>
          <el-radio label="consu">运动顾问</el-radio>
        </el-radio-group>
      </el-form-item>
      <div>若填写统一设置，不填不设置，单独设置请前往教练管理</div>
      <el-form-item label="自我介绍">
        <el-input
          type="textarea"
          v-model="self_reamrk"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="" required>
        <el-button type="primary" @click="transferExpert">转达人</el-button>
      </el-form-item>
      <h2>教练服务-给查询到的教练批量添加服务</h2>
      <div>单独添加请前往教练管理-教练详情-课程管理</div>
      <el-form-item label="服务名称" required>
        <el-input v-model="form.title" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item label="类目" required>
       <el-select v-model="course_cate" clearable>
          <el-option
            v-for="(item, index) in categories_child_list"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="价格/小时" required>
        <el-input v-model="form.amount" placeholder="68以上"></el-input>
      </el-form-item>
      <el-form-item label="" required>
        <el-button type="primary" @click="addCourse">批量添加</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categories: "",
      course_cate: "",
      form: {},
      coach: {},
      categories_child_list: [],
      list: [],
      type: "expert",
      self_reamrk: "",
    };
  },
  mounted() {
    this.getCateList();
  },
  methods: {
    queryCoach() {
      if (!this.categories) {
        return;
      }
      this.$get("/user/coach/query", {
        coach_type: "coach",
        teaching_categories: this.categories,
        sex: this.coach.sex,
        status: 2,
      }).then((res) => {
        this.list = res.data.data;
      });
    },
    transferExpert() {
      if (!this.categories) {
        return;
      }
      if (this.list.length == 0) {
        this.$message("请先搜索教练");
        return;
      }

      this.$confirm("确认将教练转成达人？").then((res) => {
        this.$message.success("已开始转换");
        let i = 0;
        let timer = setInterval(() => {
          let coach = this.list[i];
          this.updateRole(coach);
          i++;
          if (i >= this.list.length) {
            clearInterval(timer);
            this.$message.success("转换完成");
          }
        }, 500);
      });
    },
    addCourse() {
       if (!this.form.title) {
        this.$toast("请输入标题");
        return false;
      }
      if (!this.form.amount) {
        this.$toast("请输入价格");
        return false;
      }
      if (!this.course_cate) {
        return;
      }
      if (this.list.length == 0) {
        this.$message("请先搜索教练");
        return;
      }

      this.$confirm("确认批量添加课程服务？").then((res) => {
        this.$message.success("开始添加");
        let i = 0;
        let timer = setInterval(() => {
          let coach = this.list[i];
          this.addServices(coach);
          i++;
          if (i >= this.list.length) {
            clearInterval(timer);
            this.$message.success("添加完成");
          }
        }, 500);
      });
    },

    updateRole(c) {
      let url = "/user/coach/update";
      let data = {
        id: c.id,
        coach_type: "coach," + this.type,
      };
      if (this.self_reamrk) {
        data.self_introduction = this.self_reamrk;
      }
      this.$axios({
        url,
        data,
        method: "post",
      });
    },
    addServices(c) {
      let data = {
        coach_id: c.id,
        type: "service",
        pay_way: 1,
        ...this.form,
        status: 3,
        length_of_lesson: 60,
        settlement_course: 0,
        is_receiving: 1,
        venue_pay_type: 3,
        course_num: 1,
        city: "",
        address: "",
        introduce: "",
        number: "",
        create_user: 0,
        coach_name: "",
        latitude: 0,
        longitude: 0,
        categories: this.course_cate
      };
      this.$post("/user/userCourseNeed/insert", data)
    },
    getCateList() {
      let url = "/user/mechanismCategory/queryListPageChild";
      let data = {
        status: 2,
        type: 2,
        source: "课程",
      };
      this.$axios
        .get(url, {
          params: data,
        })
        .then((res) => {
          this.categories_child_list = res.data.data;
        });
    },
  },
};
</script>

<style>
</style>
